import restData from './data/restData';

export const SITE_URL = 'https://www.iggi.lv';

export const seoImages = {
    home: '/img/seo/iggi-bars.jpg',
    aboutus: '/img/seo/aboutus.jpg',
    bus: '/img/seo/izbraukumi.jpg',
    garden: '/img/seo/tirgus.png',
    cocktails: '/img/seo/kokteili.jpg',
    united: '/img/seo/united.jpg',
    faq: '/img/seo/iggi-bars.jpg',
    iggirezekne: '/img/seo/iggirezekne.jpg',
    osteria: '/img/seo/osteria.jpg',
    iggidaugavpils: '/img/seo/iggidaugavpils.jpg',
};

export function normalizePath(path = '/') {
    if (!path || path === '/') return '/';
    const prefixed = path.startsWith('/') ? path : `/${path}`;
    return prefixed.replace(/\/+$/, '');
}

export function absoluteUrl(path = '/') {
    return `${SITE_URL}${normalizePath(path)}`;
}

export function absoluteImageUrl(path = seoImages.home) {
    if (path.startsWith('http')) return path;
    return `${SITE_URL}${path}`;
}

export function cleanDescription(value = '', maxLength = 180) {
    const cleanValue = value
        .replace(/<[^>]*>/g, ' ')
        .replace(/&nbsp;/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    if (cleanValue.length <= maxLength) return cleanValue;

    const truncated = cleanValue.slice(0, maxLength - 1).replace(/\s+\S*$/, '');
    return /[.!?]$/.test(truncated) ? truncated : `${truncated}.`;
}

export function getPageSeo(page, t) {
    const pages = {
        home: {
            path: '/',
            title: t('metaTitle'),
            description: t('metaDescription'),
            image: seoImages.home,
        },
        aboutus: {
            path: '/parmums',
            title: `${t('aboutus.title')} | IGGI`,
            description: t('aboutus.metaDescription'),
            image: seoImages.aboutus,
        },
        bus: {
            path: '/izbraukumi',
            title: `${t('bus.title')} | IGGI`,
            description: t('bus.metaDescription'),
            image: seoImages.bus,
        },
        garden: {
            path: '/tirgus',
            title: `${t('garden.title')} | IGGI`,
            description: t('garden.metaDescription'),
            image: seoImages.garden,
        },
        cocktails: {
            path: '/kokteili',
            title: `${t('cocktails.title')} | IGGI`,
            description: t('cocktails.metaDescription'),
            image: seoImages.cocktails,
        },
        united: {
            path: '/united',
            title: `${t('united.title')} | IGGI`,
            description: t('united.metaDescription'),
            image: seoImages.united,
        },
        faq: {
            path: '/buj',
            title: `${t('faq')} | IGGI`,
            description: t('faqMetaDescription'),
            image: seoImages.faq,
        },
    };

    return pages[page] || pages.home;
}

export function getRestaurantSeo(rest, language = 'lv') {
    const restaurant = restData[rest];

    if (!restaurant) {
        return {
            path: `/${rest}`,
            title: 'Lapa nav atrasta | IGGI',
            description: 'Pieprasītā lapa nav atrasta.',
            image: seoImages.home,
        };
    }

    return {
        path: `/${rest}`,
        title: restaurant.title[language] || restaurant.title.lv,
        description: restaurant.metaDescription?.[language] || restaurant.description[language] || restaurant.description.lv,
        image: seoImages[rest] || seoImages.home,
    };
}

export function getOrganizationSchema(language = 'lv') {
    return {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: 'IGGI',
        url: SITE_URL,
        logo: absoluteImageUrl('/favicon.png'),
        sameAs: [
            'https://www.facebook.com/iggibars',
            'https://www.instagram.com/iggi_bars/',
        ],
        description: language === 'en'
            ? 'IGGI bars, Osteria by IGGI and catering services in Latvia.'
            : 'IGGI bāri, Osteria by IGGI un izbraukumu tirdzniecība Latvijā.',
    };
}

export function getWebsiteSchema(language = 'lv') {
    return {
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'IGGI',
        url: SITE_URL,
        inLanguage: language,
    };
}

export function getWebPageSchema(meta, language = 'lv') {
    return {
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: meta.title,
        description: cleanDescription(meta.description),
        url: absoluteUrl(meta.path),
        image: absoluteImageUrl(meta.image),
        inLanguage: language,
        isPartOf: {
            '@type': 'WebSite',
            name: 'IGGI',
            url: SITE_URL,
        },
    };
}

export function getRestaurantSchema(rest, language = 'lv') {
    const restaurant = restData[rest];
    if (!restaurant) return null;

    const socialLinks = restaurant.social
        ? Object.values(restaurant.social).map((item) => item.link)
        : [];

    return {
        '@context': 'https://schema.org',
        '@type': 'Restaurant',
        name: `${restaurant.name} ${restaurant.city}`,
        url: absoluteUrl(`/${rest}`),
        image: absoluteImageUrl(seoImages[rest] || seoImages.home),
        description: cleanDescription(restaurant.metaDescription?.[language] || restaurant.description[language] || restaurant.description.lv),
        telephone: `+371 ${restaurant.phone}`,
        priceRange: '$$',
        servesCuisine: rest === 'osteria' ? ['Italian', 'European'] : ['Bar', 'Burgers', 'Cocktails'],
        address: {
            '@type': 'PostalAddress',
            streetAddress: restaurant.address,
            addressLocality: restaurant.city,
            addressCountry: 'LV',
        },
        sameAs: socialLinks,
    };
}
